import { Contributors } from 'models/contentful/contributors/types';
import { DashHudsonUGC } from 'models/contentful/dashHudsonUGC/types';
import { GrapheneHcRecommendationsCarousel } from 'models/contentful/grapheneHcRecommendationsCarousel/types';
import { GrapheneHcRecommendationsGrid } from 'models/contentful/grapheneHcRecommendationsGrid/types';
import { Header } from 'models/contentful/header/types';
import { Hero } from 'models/contentful/hero/types';
import { HeroCarousel } from 'models/contentful/heroCarousel/types';
import { HeroHalf } from 'models/contentful/heroHalf/types';
import { Outfit } from 'models/contentful/outfit/types';
import { Picture } from 'models/contentful/picture/types';
import { ProductGrid } from 'models/contentful/productGrid/types';
import { ProductMosaic } from 'models/contentful/productMosaic/types';
import { ProductRail } from 'models/contentful/productRail/types';
import { RichText } from 'models/contentful/richText/types';
import { SizeGuideTabs } from 'models/contentful/sizeGuideTabs/types';
import { SplitHero } from 'models/contentful/splitHero/types';
import { Stories } from 'models/contentful/stories/types';
import { StoriesOverlay } from 'models/contentful/storiesOverlay/types';
import { Subscribe } from 'models/contentful/subscribe/types';
import { TwoColumnsListing } from 'models/contentful/twoColumnsListing/types';

export const HOMEPAGE_SLUG = 'HOMEPAGE';
export const EMPTYCART_SLUG = 'EMPTYCART';
export const NOTFOUND_SLUG = 'NOTFOUND';
export const NORESULTS_SLUG = 'NORESULTS';

export type ContentPageSlot =
  | ProductRail
  | ProductMosaic
  | TwoColumnsListing
  | RichText
  | Subscribe
  | ProductGrid
  | Picture
  | HeroCarousel
  | Hero
  | HeroHalf
  | SplitHero
  | Stories
  | StoriesOverlay
  | Outfit
  | Contributors
  | Header
  | SizeGuideTabs
  | DashHudsonUGC
  | GrapheneHcRecommendationsCarousel
  | GrapheneHcRecommendationsGrid;

export type CarouselSlot = Hero | HeroHalf;

export type ContentPage = {
  header: Header | null;
  browserTitle: string;
  metaTitle: string;
  metaDescription: string;
  metaImage: { url: string } | null;
  displayMode: 'block' | 'overlay';
  darkMode: boolean;
  slots: ContentPageSlot[];
};
